import { config } from '@/config/env';
import type { SupportedTags } from '@/types/SupportedTags';
import type { DocumentTemplateSourceType } from '@/types/SupportedTags';

/**
 * Suite WebApi calls made from the task pane. The supported-tags endpoint is a
 * public catalog with no per-tenant customization, so this call is anonymous —
 * no auth header, no builder/division context.
 */
export async function fetchSupportedTags(
  sourceType: DocumentTemplateSourceType,
): Promise<SupportedTags> {
  const response = await fetch(
    `${config.apiBaseUrl}/public/document-templates/supported-tags/${sourceType}`,
    {
      headers: { Accept: 'application/json' },
    },
  );

  if (!response.ok) {
    throw new Error(`Suite API returned ${response.status}: ${await response.text()}`);
  }

  return (await response.json()) as SupportedTags;
}
